import {
  GET_TRIBUN_ANOTHER_USER_REQUEST,
  GET_TRIBUN_ANOTHER_USER_SUCCESS,
  GET_TRIBUN_ANOTHER_USER_FAILURE,

  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE,

  BLOCK_ANOTHER_USER_REQUEST,
  BLOCK_ANOTHER_USER_SUCCESS,
  BLOCK_ANOTHER_USER_FAILURE,

  UNBLOCK_ANOTHER_USER_REQUEST,
  UNBLOCK_ANOTHER_USER_SUCCESS,
  UNBLOCK_ANOTHER_USER_FAILURE,

  RESET_TRIBUN_PROFILE
} from 'Store/constants';

const initialState = {
  isLoading: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {

    case GET_TRIBUN_ANOTHER_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_TRIBUN_ANOTHER_USER_SUCCESS:
      return { ...state, ...action.payload, isLoading: false, error: null };
    case GET_TRIBUN_ANOTHER_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case FOLLOW_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };

    case FOLLOW_TRIBUN_USER_SUCCESS:
    {
      if (action.tabType === 'profile') {
        state.following = !state.following;
        state.stats.followers = action.payload.followerCount;
        if (!state.following && state?.watching) {
          state.watching = false;
        }
      }
      return { ...state, isLoading: false, error: null };
    }

    case FOLLOW_TRIBUN_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case BLOCK_ANOTHER_USER_REQUEST:
      return { ...state,
        isLoading: true, error: null
      };

    case BLOCK_ANOTHER_USER_SUCCESS:
      return { ...state, blockedByUser: true,
        userBlockData: { isBlockedByUser: true },
        isLoading: false, error: null };


    case BLOCK_ANOTHER_USER_FAILURE:
      return { ...state, userBlockData: { isBlockedByUser: null }, isLoading: false, error: action.payload };

    case UNBLOCK_ANOTHER_USER_REQUEST:
      return { ...state,
        isLoading: true, error: null
      };
    
    case UNBLOCK_ANOTHER_USER_SUCCESS:
      return { ...state, blockedByUser: false,
        userBlockData: { isBlockedByUser: false },
        isLoading: false, error: null };

    case UNBLOCK_ANOTHER_USER_FAILURE:
      return { ...state, userBlockData: { isBlockedByUser: null }, isLoading: false, error: action.payload };
      

    case RESET_TRIBUN_PROFILE:
      return { ...initialState };
    default:
      return state;
  }
};
